<template>
  <v-chip
    :color="color"
    class="ml-0 mr-2 font-weight-bold white--text"
    label
    x-small
    >{{ text }}</v-chip
  >
</template>

<script>
export default {
  props: {
    status: String,
  },

  data() {
    return {
      statusList: {
        draft: {
          color: "gray",
          text: "Draft",
        },
        overdue: {
          color: "error",
          text: "Overdue",
        },
        paid: {
          color: "success",
          text: "Paid",
        },
        partially_paid: {
          color: "warning",
          text: "Partially Paid",
        },
        sent: {
          color: "info",
          text: "Sent",
        },
      },
    };
  },
  computed: {
    colorize() {
      let status = this.status.toLowerCase();
      if (this.statusList[status]) {
        return this.statusList[status];
      }
      return {
        color: "secondary",
        text: this.status ? this.status : "Not set",
      };
    },
    color() {
      return this.colorize.color;
    },
    text() {
      return this.colorize.text;
    },
  },
};
</script>